import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {GlobalValidator} from '../../../shared/validators/global-validator';
import {RulesService} from '../../rules.service';
import {Router} from '@angular/router';
import {PageCanDeactivate} from '../../common/can-deactivate/can-deactivate-page';

@Component({
  selector: 'app-setup-action',
  templateUrl: './setup-action.component.html',
  styleUrls: ['./setup-action.component.scss']
})
export class SetupActionComponent extends PageCanDeactivate implements OnInit {
  actionList = [];
  constructor(private ruleService: RulesService,
              private router: Router) { super(); }
  ngOnInit() {
    if (!this.ruleService.rows || !this.ruleService.rows.length) {
      this.goToFirstStep();
      return;
    }
    this.getActionsList();
  }

  get hasChanges(): boolean {
    return this.ruleService.rows && !!this.ruleService.rows.length;
  }
  get mailAction() {
    return this.actionList.length ? this.actionList[0] : null;
  }
  getActionsList() {
    this.actionList = this.ruleService.getActionList();
  }
  goToFirstStep() {
    this.router.navigate(['rules/new/step-1']);
  }
}



// WEBPACK FOOTER //
// ./src/app/rules/new-rule/setup-action/setup-action.component.ts